// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DatetimeController from "./datetime_controller"
application.register("datetime", DatetimeController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TicketCalculatorController from "./ticket_calculator_controller"
application.register("ticket-calculator", TicketCalculatorController)

import TicketsController from "./tickets_controller"
application.register("tickets", TicketsController)

import TrustedTypesController from "./trusted_types_controller"
application.register("trusted-types", TrustedTypesController)
